import { ArrowDownward } from '@mui/icons-material';
import { Button } from '@mui/material';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from 'store';
import { SpecificRowsLabelerPage } from './LabelerPage';

export let pageChrono: number = 0;
let groupPageChrono: number = 0;

export const LabelerPrint = () => {

    const currentLabel = useSelector((state: RootState) => state.labelEditor.currentLabel);
    const currentSheet = useSelector((state: RootState) => state.labelEditor.currentSheet);
    const printLayout = useSelector((state: RootState) => state.labelEditor.printLayout);
    const navigate = useNavigate();

    console.log('currentLabel', currentLabel);

    useEffect(() => {
        window.scrollTo(0, 0);

        pageChrono = 0;
        groupPageChrono = 0;

    }, []);


    const goBack = () => {
        window.history.back();
    };

    if (!currentLabel) {
        navigate('labeler');
        return;
    }

    const perPage: number = currentLabel?.configuration.labelCountHorizontally * currentLabel?.configuration.labelCountVertically;

    const content = () => {
        let output: React.JSX.Element[] = [];
        if (printLayout && currentSheet) {
            for (let groupName of Object.keys(printLayout.groups)) {
                output = output.concat(renderGroupLayout(printLayout.groups[groupName], perPage, groupName));
            }
            output = output.concat(renderGroupLayout(printLayout.orphans, perPage));
            return output;
        } else {
            output = renderGroupLayout(currentSheet.values.map((_p, i) => i) ?? [], perPage);
        }
        return output;
    };


    return <>{currentLabel.template.paper.css ? <link rel="stylesheet" href={"./assets/labels/pages/" + currentLabel.template.paper.css} /> : null}<div className='no-print'>
        <div style={{ textAlign: 'center' }}>
            <p><Button variant='contained' onClick={goBack}>Retour</Button></p>
            <h2>Imprime ça (CTRL + P)<br /><ArrowDownward /><ArrowDownward /><ArrowDownward /></h2>
        </div>
    </div><div className='print' style={{ textAlign: 'center' }}>{content()}</div>{launchPrint()}</>;
};


const renderGroupLayout = (rows: number[], perPage: number, pageLabel?: string): React.JSX.Element[] => {
    const out: React.JSX.Element[] = [];
    const rowsCopy: number[] = [...rows];
    groupPageChrono = 0;
    while (rowsCopy.length) {
        const currentRows: number[] = rowsCopy.splice(0, perPage);
        out.push(<SpecificRowsLabelerPage key={pageChrono} rows={currentRows} pageNumber={++pageChrono} pageGroupName={pageLabel} pageGroupNumber={++groupPageChrono} pageGroupTotal={Math.ceil(rows.length / perPage)} />);
    }
    return out;
};

const launchPrint = (): React.JSX.Element => {
    //setTimeout(() => { window.print(); }, 5000);
    return <></>;
};
